import axiosWrapper from './axiosWrapper'; // eslint-disable-line import/no-cycle

export default axiosWrapper;
